import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";

import { createShipmentPackageApi, createUserAdminApi, updateShippingPackageApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedCalPackage, clearSelectedPackage, clearSelectedUser } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const initialFormData = {
    fullName: "",
    customerCategory : "B2B",
    email: "",
    password: "",
    countryCode: "",
    mobile: "",
};

const initialFormErrors = {
  fullName: "",
  customerCategory: "",
  email: "",
  password: "",
  countryCode: "",
  mobile: "",
};


const CreateAdminUsers = () => {

    
    const navigate = useNavigate()
    const [formData, setFormData] = useState(initialFormData);
    const [formErrors, setFormErrors] = useState(initialFormErrors);

    const { selectedUser } = useSelector((state) => state.authModal);
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;

    const [id, setId] = useState("")


    // const fullName = `${formData?.firstName || ""} ${formData?.lastName || ""}`.trim();




    const validateField = (name, value) => {
        let error = "";

        switch (name) {
            case "fullName":

                if (!value.trim()) error = "This field is required.";
                else if (!/^[a-zA-Z\s]+$/.test(value)) error = "Only letters and spaces are allowed.";
                break;
            case "email":
                if (!value) error = "Email is required.";
                else if (!/^\S+@\S+\.\S+$/.test(value)) error = "Invalid email.";
                break;
            // case "password":
            //     if (!value) error = "Password is required.";
            //     else if (value.length < 6) error = "Minimum 6 characters.";
            //     break;
            case "mobile":
                if (!value) {
                  error = "Mobile is required.";
              } else {
                  if (formData.countryCode === "+86") {
                      if (!/^\d{11}$/.test(value)) {
                          error = "Enter an 11-digit mobile number for China.";
                      }
                  } else {
                      if (!/^\d{10}$/.test(value)) {
                          error = "Enter a 10-digit mobile number.";
                      }
                  }
              }
              break;
            case "countryCode":
                if (!value) error = "Select country code.";
                break;
            case "customerType":
                if(!value) error = "Select User Category"
                break
            default:
                break;
        }

        setFormErrors((prev) => ({ ...prev, [name]: error }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        validateField(name, value);




    };


    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);



    const [pakWeight, setPakWeight] = useState('');
    const [airDuration, setAirDuration] = useState('');

    const [airCost, setAirCost] = useState('');
    const [shipDuration, setShipDuration] = useState('');
    const [shipCost, setShipCost] = useState('');




    const [shipPackageId, setShipPackageId] = useState(''); // can be generated or user-input






    const handleCreateUser = async (e) => {
        e.preventDefault();

        // Validate all fields before submission
        Object.entries(formData).forEach(([name, value]) =>
            validateField(name, value)
        );
        console.log("Form Errors",formErrors);
        
        const isFormValid = Object.values(formErrors).every((e) => !e);
        console.log(isFormValid);
        
        if (isFormValid) {
            console.log("Form submitted:", formData);
            try {
              console.log(formData);
              
                const data = await createUserAdminApi({ id: id, country_code: formData?.countryCode, email: formData?.email, fullname: formData?.fullName, mobilenumber: formData?.mobile, customerCategory : formData.customerCategory });
                console.log(data)
                toast.success("User Created Successfully")


                setFormData({
                    fullName: "",

                    email: "",
                    password: "",
                    countryCode: "",
                    mobile: "",

                })

                navigate("/customers")





                // setOrderUsers(data)

                // setOrderCategories(data?.categories)
                // toast.success("Email Templates fetched successfully!", { id: toastId });
            } catch (err) {
                console.error("Fetch Error:", err);


                toast.error(
                    err || "Something went wrong while creating user",

                );
            } finally {

            }
        } else {
            console.log("Fix form errors first.");
        }
    };
    
console.log("user Id", id)


    useEffect(() => {
        if (selectedUser) {




            setFormData({
                fullName: selectedUser?.fullname || "",

                email: selectedUser?.email || "",
                password: selectedUser?.password || "",
                countryCode: selectedUser?.country_code || "",
                mobile: selectedUser?.mobilenumber || "",



            })

            setId(selectedUser?.id || "")











        }

        return () => {

            dispatch(clearSelectedUser());
        };
    }, [selectedUser, dispatch]);

    const handleNumericInput = (e, setter) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setter(value);
        }
    };

    return (
      <div className="row gy-4">
        <div className="col-lg-12">
          <div className="card mt-24">
            <div className="card-header border-bottom">
              <h6 className="text-xl mb-0">Create User</h6>
            </div>
            <div className="card-body p-24">
              <form
                onSubmit={handleCreateUser}
                className="d-flex flex-column gap-20"
              >
                <div className="row">
                  <div className="col-md-6 col-12 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="pakWeight"
                    >
                      Full Name :
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      placeholder="Enter Full Name"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                    />

                    {formErrors.fullName && (
                      <small className="text-danger">
                        {formErrors.fullName}
                      </small>
                    )}
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="airDuration"
                    >
                      Email :
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      placeholder="Enter Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />

                    {formErrors.email && (
                      <small className="text-danger">{formErrors.email}</small>
                    )}
                  </div>

                  {/* <div className="col-md-6 col-12 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='pakWeight'>

                                        Last Name :
                                    </label>
                                    <input
                                        type='text'
                                        required

                                        placeholder="Enter Last Name" className='form-control border border-neutral-200 radius-8'
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                    />

                                    {formErrors.lastName && <small className="text-danger">{formErrors.lastName}</small>}
                                </div> */}
                </div>

                <div className="row">
                  {/* <div className="col-12 col-md-6 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='airCost'>
                                        Password :
                                    </label>
                                    <input
                                        // type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        type="password"
                                        //  className="form-control radius-8"
                                        placeholder="Enter Password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                    />

                                    {formErrors.password && <small className="text-danger">{formErrors.password}</small>}

                                </div> */}
                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="shipDuration"
                    >
                      Country Code :
                    </label>

                    <select
                      className="form-control border border-neutral-200 radius-8"
                      name="countryCode"
                      value={formData.countryCode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Country Code --</option>
                      <option value="+91">+91 - India</option>
                      <option value="+86">+86 - China</option>
                      <option value="+1">+1 - Canada</option>
                      <option value="+1-US">+1 - USA</option>
                    </select>
                    {formErrors.countryCode && (
                      <small className="text-danger">
                        {formErrors.countryCode}
                      </small>
                    )}
                  </div>

                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="shipCost"
                    >
                      Mobile Number :
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      placeholder="Enter Mobile"
                      name="mobile"
                      value={formData.mobile}
                      // onChange={handleChange}
                      // onKeyPress={(e) => {
                      //   if (!/[0-9]/.test(e.key)) {
                      //     e.preventDefault();
                      //   }
                      // }}
                      // maxLength={10}
                      onChange={(e) => {
                        // Limit digits manually in case user pastes too many
                        const value = e.target.value.replace(/\D/g, '');
                        const limit = formData.countryCode === '+86' ? 11 : 10;
                        if (value.length <= limit) {
                          setFormData({ ...formData, mobile: value });
                        }
                      }}
                      onKeyPress={(e) => {
                        // Only allow numeric input
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      maxLength={formData.countryCode === '+86' ? 11 : 10}
                    />
                    {console.log(formData)}
                    
                    {formErrors.mobile && (
                      <small className="text-danger">{formErrors.mobile}</small>
                    )}
                  </div>

                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="shipDuration"
                    >
                      Customer Category :
                    </label>

                    <select
                      className="form-control border border-neutral-200 radius-8"
                      name="customerCategory"
                      value={formData.customerCategory}
                      onChange={handleChange}
                      required
                    >
                      <option value="B2B">Business (B2B)</option>
                      <option value="B2C">Individual (B2C)</option>
                    </select>
                    {formErrors.customerCategory && (
                      <small className="text-danger">
                        {formErrors.customerCategory}
                      </small>
                    )}
                  </div>
                </div>

                <div className="row"></div>

                <button
                  type="submit"
                  className="btn btn-primary-600 radius-8 col-md-1 col-12"
                >
                  Create User
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
};

export default CreateAdminUsers;
